<span class="snackbar-mark"> Content Reverted to Original </span>
